import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, apiActionResult } from "../../common";
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import { authTokenSelector } from '../../session';
import getUserBookmarks from './getUserBookmarks';

const actions = createActions({
  USER: {
    ADD_USER_BOOKMARK: (contentId) => ({ contentId }),
    API: {
      ADD_USER_BOOKMARK: apiResourceActionCreator('bookmarks'),
    }
  }
});

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.Bookmarks), authToken, payload, actions.user.api.addUserBookmark);

export function* addUserBookmark(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload));

    const addUserBookmarkResult = yield apiActionResult(actions.user.api.addUserBookmark);

    if (addUserBookmarkResult.success) {
      yield put(getUserBookmarks.action.user.getUserBookmarks());
    }
  }
};

const configuration = {
  name: 'addUserBookmark',
  action: actions,
  sagas: addUserBookmark,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    }),
  }
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/addUserBookmark.js